import useFirebaseData from "./useFirebaseData";
import type { FirebaseRecord, Firing } from "../types";

const useSharedFirebaseFirings = (sharing_user_id: string) => {
  return useFirebaseData<FirebaseRecord<Firing>>(
    sharing_user_id ? `/shared_userdata/${sharing_user_id}/firings` : null
  );
};

export default useSharedFirebaseFirings;
